/**
 * PatientListSection
 *
 * Patient list with 8-column header.
 * Passes bestSlot and onOfferBestSlot to each PatientRow for inline quick-offer.
 */
import React from 'react';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import PatientRow from './PatientRow';
import styles from '../WaitingListV2Page.module.css';

const headerStyle = {
  fontSize: '0.7rem',
  fontWeight: 600,
  color: '#94a3b8',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
};

function PatientListSection({
  patients = [],
  suggestionsMap = {},
  bestSlotMap = {},       // waitingListItemId → best slot object
  getPatientById,
  getProcedureById,
  getResourceById,
  onViewSuggestions,
  onOfferBestSlot,        // (item, bestSlot) => void
  onDelete,
  onEdit,
}) {
  if (patients.length === 0) {
    return (
      <div className={styles.emptyState}>
        <PeopleOutlineIcon className={styles.emptyIcon} />
        <div className={styles.emptyTitle}>Nenhum paciente na lista de espera</div>
        <div className={styles.emptySubtitle}>
          Adicione pacientes para começar a encontrar horários compatíveis.
        </div>
      </div>
    );
  }

  return (
    <div className={styles.patientList}>
      {/* Table header */}
      <div className={styles.patientRow} style={{ background: '#f8fafc', borderBottom: '1px solid #f1f5f9' }}>
        <span style={headerStyle}>Paciente</span>
        <span style={headerStyle}>Procedimento</span>
        <span style={headerStyle}>Profissional preferido</span>
        <span style={headerStyle}>Prioridade</span>
        <span style={headerStyle}>Tempo de espera</span>
        <span style={headerStyle}>Sugestões</span>
        <span style={headerStyle}>Status</span>
        <span style={{ ...headerStyle, textAlign: 'right' }}>Ações</span>
      </div>

      {/* Patient rows */}
      {patients.map((item) => {
        const patient = getPatientById(item.patientId + '');
        const procedure = getProcedureById(item.procedureId);
        const resource = item.resourceId ? getResourceById(item.resourceId) : null;
        const suggestionsCount = suggestionsMap[item.id] || item.availableDates?.length || 0;
        const bestSlot = bestSlotMap[item.id] || null;

        return (
          <PatientRow
            key={item.id}
            item={item}
            patient={patient}
            procedure={procedure}
            resource={resource}
            suggestionsCount={suggestionsCount}
            bestSlot={bestSlot}
            onViewSuggestions={onViewSuggestions}
            onOfferBestSlot={onOfferBestSlot}
            onDelete={onDelete}
            onEdit={onEdit}
          />
        );
      })}
    </div>
  );
}

export default PatientListSection;
